import idlRaw from "./idlRaw.json";
export const idl = idlRaw;
